// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "iframe[data-v-4124dca2] {\n  width: 100%;\n  height: 100%;\n  background: #fff;\n}\n.pc-frame[data-v-4124dca2] {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n}\n.m-frame[data-v-4124dca2] {\n  width: 375px;\n  height: 100vh;\n  margin: 0 auto;\n}", ""]);
// Exports
module.exports = exports;
